import { CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";

const EventList = ({ eventIds }) => {
  const [eventData, setEventData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      console.log("loading");

      const promises = eventIds.map(async (id) => {
        try {
          const response = await fetch(`http://localhost:5000/event/${id}`);
          if (!response.ok) {
            throw new Error(`Error fetching event data for ID ${id}`);
          }
          const eventData = await response.json();
          return eventData;
        } catch (error) {
          console.error(error);
          return null; // Handle errors as needed
        }
      });

      const eventResults = await Promise.all(promises);
      setIsLoading(false);
      console.log("loading false");
      setEventData(eventResults.filter((data) => data !== null));
    };

    fetchData();
  }, [eventIds]);

  return (
    <div>
      <h1>Event List</h1>
      {isLoading && <CircularProgress />} {/* Display loading spinner */}
      <ul>
        {eventData.map((event, index) => (
          <li key={index}>
            {event ? (
              <>
                <strong>Name:</strong> {event?.event?.name}<br />
                <strong>Location:</strong> {event?.event?.location}<br />
                <strong>Date:</strong> {event?.event?.date}
              </>
            ) : (
              "Event data not available"
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default EventList;
